import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-delivery-methods',
  templateUrl: './delivery-methods.component.html',
  styleUrls: ['./delivery-methods.component.css'],
  standalone: false
})
export class DeliveryMethodsComponent implements OnInit {
    public setting?: Setting;

    public itemsListDeliveryMethods: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2171))[0];
    }

    private async loadDeliveryMethods(): Promise<void> {
        this.itemsListDeliveryMethods = await this.datatask.Post(385);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'deliverymethod':
                this.stateService?.go('deliverymethod', { deliverymethod_no: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadSetting();
        this.loadDeliveryMethods();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filterval: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deliveryMethods', {
//        templateUrl: 'views/components/views/deliveryMethods/deliveryMethods.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'deliveryMethodsService', 'rememberService', 'layoutService', function (stateService, utilityService, deliveryMethodsService, rememberService, layoutService) {
//            const vm = this;

//            let variableNames = {
//                filterval: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filterval') }
//                ],
//                setting: {},
//                itemsListDeliveryMethods: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await deliveryMethodsService.getSetting())[0];
//            }

//            async function loadDeliveryMethods() {
//                vm.model.itemsListDeliveryMethods = (await deliveryMethodsService.listDeliveryMethods());
//            }

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'filterval':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            function clear(id) {
//                switch (id) {
//                    case 'filterval':
//                        vm.model.setting.filterval = '';

//                        if (vm.model.setting.filterval === '') rememberFunc('filterval');
//                        break;
//                    default:
//                        break;
//                };
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'deliverymethod':
//                        go({ deliverymethod_no: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'filterval':
//                        if (vm.model.setting.filterval > '') rememberFunc('filterval');
//                        break;
//                    default:
//                        break;
//                };
//            };

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'filterval':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.filterval) !== true) return;

//                        vm.model.setting.filterval = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.filterval, true) !== true) return;

//                        if (vm.model.setting.filterval === '') rememberFunc('filterval');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadSetting();
//                loadDeliveryMethods();
//            };
//        }]
//    });
//})();
